import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const useCampaignReveal = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const items = document.querySelectorAll('.hhc-campaign-page .hhc-reveal');
    if (!items.length) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('on');
          }
        });
      },
      { threshold: 0.2 }
    );

    items.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, [i18n.language]);
};

export default useCampaignReveal;
